import React, { useEffect, useMemo, useState } from 'react';
import appManager, { logEvent } from 'AppManager';
import { ActivityIndicator, withConfirmationModal } from 'LocalGluons';
import { View } from 'react-native';
import SimpleNotification from './SimpleNotifications';

const SimpleNotificationsProvider = (props) => {
    const { children, setModalContent } = props;
    const [notificationsData, setNotificationsData] = useState(null);

    const {
        backstageConnector: { notifications }
    } = appManager.getApi();


    useEffect(() => {
        chceckForNotification();
    }, []);

    const logData = useMemo(() => {
        if (notificationsData && notificationsData.length > 0)
            logEvent({
                type: 'action',
                subtype: 'notificationOpen',
                content1: notificationsData[0].id,
                content2: notificationsData[0].name,
            });
    }, [notificationsData]);

    useEffect(() => {
        if (notificationsData && notificationsData.length > 0) {
            logData;
            return setModalContent(
                <SimpleNotification
                    setModalContent={setModalContent}
                    notifiactionResponse={notificationsData[0].smallScreen}
                    notificationID={notificationsData[0].id}
                    notificationName={notificationsData[0].name}
                />,
            );
        }
    }, [notificationsData]);

    const chceckForNotification = async () => {
        try {
            const notificationData = await notifications.getSimpleNotificationsV2();
            setNotificationsData(notificationData.items);

        } catch (error) {
            setNotificationsData([]);
            console.log('SimpleNotificationProvider "chatch": ', error);
        }
        return;
    };

    useEffect(() => {
        chceckForNotification();
    }, []);

    return (
        <View
            style={{ flex: 1 }}
        >
            {(notificationsData === null) ? <ActivityIndicator /> : children}
            {/* {children} */}
        </View>
    );
};

export default withConfirmationModal(SimpleNotificationsProvider);